import { Observable } from 'rxjs';
import { Country, DataSourceResponse } from '../../models';
import { Injectable } from '@angular/core';
import { ApiService } from '@meddatacore/common';
import { HttpParamsEncoder } from '../../tools';

@Injectable()
export class CountryService extends ApiService {
  endPoint = '/api/countries';
  create(model: Country) {
    return this.http.post(`${this.commonBaseURL}${this.endPoint}`, model);
  }

  update(id: string, model: Country) {
    return this.http.put(`${this.commonBaseURL}${this.endPoint}/${id}`, model);
  }

  delete(id: string) {
    return this.http.delete<any>(`${this.commonBaseURL}${this.endPoint}/${id}`);
  }
  deleteRange(ids: string[]) {
    return this.http.post<any>(`${this.commonBaseURL}${this.endPoint}/deleteRange`, ids);
  }
  get(id: string): Observable<Country> {
    return this.http.get<Country>(`${this.commonBaseURL}${this.endPoint}/${id}`);
  }

  getCountries(queryParams?: any): Observable<DataSourceResponse<Country>> {
    const params = new HttpParamsEncoder().encode(queryParams);
    return this.http.get<any>(`${this.commonBaseURL}${this.endPoint}`, { params });
  }
}
